import React, { Component } from 'react'
import { Switch, Route as ReactRoute, Redirect } from 'react-router-dom';
import CallbackPage from '../auth/callback.component';
import DashboardComponent from '../components/dashboard.component'
import Transactions from '../components/Transactions'
import CreatePaymentLink from '../components/createpaymentlink/createPaymentLink';
import ViewPaymentLinksComponent from '../components/dashboard.component/viewPaymantLinks';
import ViewTransactionComponent from '../components/dashboard.component/transactions/viewtransactioncomponent';
import TransactionDetails from '../components/dashboard.component/transactions/transactiondetails';
import CreatePaymentInvoice from '../components/createpaymentlink/createPaymentInvoice';
import PaymentMethod from '../components/createpaymentlink/paymentMethod';
import Auth0 from '../components/auth0.component/auth0';
import EmailVerification from '../components/auth0.component/emailVerification';
import PhoneVerification from '../components/auth0.component/phoneVerification';
import SumSub from '../components/sumSub.component/sumsub';
import Notkyc from '../components/sumSub.component/notKyc';
import AccountStatus from '../utils/accountStatus'
import TransferComponent from '../components/transfer.component/index';
import Web3Dashboard from './web3Dashboard';
import ProtectedRoute from '../auth/protectedRoute';
import PendingCommissions from '../components/transfer.component/pendingCommissions';
import PaymentLinkView from '../components/createpaymentlink/pamentLinksView';
class RouteConfig extends Component {
    render() {
        return <Switch>
            <ReactRoute exact path={`/`} ><Redirect to='/dashboard' /></ReactRoute>
            <ReactRoute path={`/welcome`} ><Web3Dashboard /></ReactRoute>
            <ReactRoute path={`/dashboard`} ><ProtectedRoute><DashboardComponent /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/transactions`} ><ProtectedRoute><Transactions /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/transfer`} ><ProtectedRoute><TransferComponent /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/createpaymentlink/:id?`} ><ProtectedRoute><CreatePaymentLink /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/paymentLinkView/:id?/:merchantName?`} ><ProtectedRoute><PaymentLinkView /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/paymentlinks`} ><ProtectedRoute><ViewPaymentLinksComponent /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/viewtransactions`} ><ProtectedRoute><ViewTransactionComponent /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/transactionDetails/:id?/:type?`} ><ProtectedRoute><TransactionDetails /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/createpaymentinvoice/:id?/:merchantName?`} ><ProtectedRoute><CreatePaymentInvoice /></ProtectedRoute></ReactRoute>
            <ReactRoute path={`/paymentmethod/:id?`} ><ProtectedRoute><PaymentMethod /></ProtectedRoute></ReactRoute>
            <ReactRoute path="/callback" component={CallbackPage} />
            <ReactRoute path="/auth0" component={Auth0} />
            <ReactRoute path="/emailVerification" component={EmailVerification} />
            <ReactRoute path="/phoneVerification" component={PhoneVerification} />
            <ReactRoute path="/sumsub" component={SumSub} />
            <ReactRoute path="/notkyc" component={Notkyc} />
            <ReactRoute path="/accountstatus" component={AccountStatus} />
            <ReactRoute path="/pendingcommissions" ><ProtectedRoute><PendingCommissions /> </ProtectedRoute> </ReactRoute>

        </Switch>
    }
}

export default RouteConfig;